import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

function ScanReportRadioGroup(props) {
    return (
        <RadioGroup 
            value={props.radio} 
            onChange={props.handleRadioChange}
            style={{
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: 16,
                paddingBottom: 10
            }}
        >
        {
            Object.keys(props.radios).map((key, index) => (
                <FormControlLabel 
                    key={`driverdispatch-scanreport-radio-${index}`} 
                    id={`driverdispatch-scanreport-radio-${index}`}
                    value={key} 
                    control={<Radio />} 
                    label={props.radios[key].text} 
                /> 
            ))
        }
        </RadioGroup>
    )
}
export default ScanReportRadioGroup;